document.addEventListener('rebuy:smartcart.init', () => {
  window.hasSwitchToSubscriptionHandle = async function (item) {
    const getProduct = await fetch(`/products/${item.product.handle}.js`).then((res) => res.json())
    const variant = getProduct.variants.find(variant => variant.id === item.variant_id)
    const sellingPlanAllocations = variant.selling_plan_allocations.length
    if (sellingPlanAllocations) {
      return sellingPlanAllocations
    } else {
      const subscriptionEl = document.querySelector(`.js-subscription-${variant.id}`)
      if (subscriptionEl) {
        subscriptionEl.style.display = 'none'
      }
    }
  }
});
